/* eslint-disable @typescript-eslint/no-explicit-any */
import apiRoutes from "@/src/apiRoutes";
import Screen from "@/src/components/Screen";
import { textVariants } from "@/src/components/Text/Text";
import api, { copy } from "@/src/utils";
import { useQuery } from "@tanstack/react-query";
import { Link, useNavigate, useParams } from "react-router-dom";
import { InitiateTradeData, Message, TradeComponentsData } from "../types";
import Chat from "./Chat";
import VerticalStepper from "@/src/components/VerticalStepper";
import moment, { Moment } from "moment";
import Actions from "./Actions";
import { useEffect, useState } from "react";
import { Centrifuge } from "centrifuge";
import { useAppSelector } from "@/src/app/hooks";
import { cn } from "@/lib/utils";
import CopyIcon from "@assets/icons/Copy.svg";
import _ from "lodash";
import { useMediaQuery } from "usehooks-ts";
import { Tabs, TabsList, TabsTrigger } from "@/src/components/shad/tabs";
import { Modal } from "@/src/components/Modal/Modal";
import greenMark from "@assets/greenmark.svg";
import { Button } from "@/src/components/Button/Button";
import { useTranslation } from "react-i18next";
import { TOptions } from "i18next";
// import useRetry from "@/src/hooks/useTime"

const TradeDetails = () => {
  const { t } = useTranslation();
  const trans = (key: string, options?: TOptions) =>
    t(`app.p2p.viewTrade.${key}`, options);
  const { id } = useParams();
  const [actions, setActions] = useState<Array<string>>([]);
  const { user } = useAppSelector((state) => state.user);
  const isMobile = useMediaQuery("(max-width: 1024px)");
  const [tab, setTab] = useState("details");
  const [timing, setTiming] = useState<string>();
  const [messages, setMessages] = useState<Message[]>([]);
  const [successModal, setSuccessModal] = useState(false);
  const [successData, setSuccessData] = useState<any>(undefined);

  const navigate = useNavigate();

  const getTradeDetails = async () => {
    const res = await api.post(`${apiRoutes.trade}${id}/`, {
      type: "fetch_preview_components",
    });
    return res.data;
  };

  const { data, isLoading } = useQuery<InitiateTradeData>({
    queryKey: ["get_trade_info", actions],
    queryFn: getTradeDetails,
  });

  const getTradeInfo = async () => {
    const res = await api.post(`${apiRoutes.trade}${id}/`, {
      type: "fetch_components",
    });
    return res.data;
  };

  const { data: TradeDetails } = useQuery<TradeComponentsData>({
    queryKey: ["get_trade_components"],
    queryFn: getTradeInfo,
  });

  function calculateTimeLeft(endTime: Moment) {
    // Get the current time
    const now = moment();

    // Calculate the difference in milliseconds
    const duration = moment.duration(endTime.diff(now));

    // Extract minutes and seconds from the duration
    const minutes = Math.floor(duration.asMinutes());
    const seconds = Math.floor(duration.asSeconds()) % 60;

    return { minutes, seconds };
  }

  const timeLeft = calculateTimeLeft(moment(data?.info.time_left));

  // Countdown timer
  useEffect(() => {
    const interval = setInterval(() => {
      const now = moment();
      const endTime = moment(data?.info.time_left);
      const duration = moment.duration(endTime.diff(now));
      const minutes = Math.floor(duration.asMinutes());
      const seconds = Math.floor(duration.asSeconds()) % 60;
      if (minutes > 0 || seconds > 0) {
        setTiming(minutes + ":" + seconds);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [data]);

  useEffect(() => {
    const wsClient = new Centrifuge(
      "wss://bitcoinzoomtraining.com/centrifugo/connection/websocket",
      {
        token: TradeDetails?.info?.token,
      }
    );
    wsClient.connect();
    // Add username with the trade id to fetch specific trade details to the user
    const sub = wsClient?.newSubscription(`${id}/${user?.username}`);
    // Subscription to get messages sent
    const Chatsub = wsClient?.newSubscription(id as string);

    sub.subscribe();
    Chatsub.subscribe();

    // wsClient.on("connected", (ctx) => {
    //   console.log("connected td", ctx);
    // });

    sub.on("publication", (ctx) => {
      if (ctx?.data.type === "trade-detail") {
        setActions(ctx?.data.data.info.states);
        if (ctx?.data.data.info.status === "Completed") {
          setSuccessModal(true);
          setSuccessData(ctx?.data.data.info);
        }
      }
    });

    Chatsub.on("publication", (ctx) => {
      if (ctx?.data.type === "message") {
        setMessages((old) => [...old, ctx?.data.data]);
      }
    });

    // wsClient.on("disconnected", (ctx) => {
    //   console.log("disconnected td", ctx);
    // });

    // wsClient.on("unsubscribed", (ctx) => {
    //   console.log("unsubscribed ", ctx);
    // });
    return () => {
      if (wsClient) {
        sub.unsubscribe();
        Chatsub.unsubscribe();
        wsClient?.disconnect();
      }
    };
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [TradeDetails?.info?.token]);

  return (
    <Screen loading={isLoading}>
      <div className="lg:hidden flex  fixed top-18 left-0  w-full ">
        <div className="w-full bg-white dark:bg-grey-800 px-1">
          <Tabs
            defaultValue={"details"}
            onValueChange={(val) => setTab(val)}
            className="flex-1"
          >
            <TabsList className="lg:w-1/3 md:w-1/2 w-full">
              <TabsTrigger
                className="data-[state=active]:bg-[#2F60E0] data-[state=active]:text-white flex-1"
                value="details"
              >
                Trade Details
              </TabsTrigger>
              <TabsTrigger
                className="data-[state=active]:bg-[#2F60E0] data-[state=active]:text-white flex-1"
                value="chat"
              >
                Chat
              </TabsTrigger>
            </TabsList>
          </Tabs>
        </div>
      </div>
      <div className=" grid lg:grid-cols-2 gap-10 h-[80vh] overflow-x-hidden overflow-y-scroll mt-14 lg:mt-5 ">
        {(!isMobile || (isMobile && tab === "details")) && (
          <div>
            <div>
              {!data?.info.dispute_raised && (
                <div className="flex items-center gap-2">
                  <img
                    className="h-5 w-5"
                    src={data?.info?.coin_image}
                    alt={"crypto"}
                  />
                  <span className={textVariants()}>
                    {data?.info?.type === "seller"
                      ? trans("sellHeader", {
                          coin: data?.info?.coin_ticker.toUpperCase(),
                        })
                      : trans("buyHeader", {
                          coin: data?.info?.coin_ticker.toUpperCase(),
                        })}
                  </span>
                  <Link
                    to={"/app/trade/trader_info/" + data?.info?.partner}
                    // target="_blank"
                    className="bg-blue-600 px-4 py- rounded-3xl text-white"
                  >
                    {data?.info?.partner}
                  </Link>
                </div>
              )}
              {!data?.info.dispute_raised && (
                <div className="flex items-center gap-2">
                  <span className={textVariants({ variant: "desc" })}>
                    {data?.info?.type === "seller"
                      ? trans("sellerDesc")
                      : trans("buyerDesc")}
                  </span>
                  {timeLeft?.minutes < 0 ? (
                    <span className="text-green-600">0s</span>
                  ) : (
                    <span className="text-green-600">{timing}s</span>
                  )}
                </div>
              )}
              {!data?.info.dispute_raised && (
                <div className="mt-4">
                  <VerticalStepper
                    steps={[
                      {
                        element: (
                          <div className="grid gap-5 mt-3">
                            <div className="grid gap-3">
                              <div className="flex justify-between">
                                <span
                                  className={textVariants({ variant: "desc" })}
                                >
                                  {data?.info?.type === "buyer"
                                    ? trans("details.price.buyerTitle")
                                    : trans("details.price.sellerTitle")}
                                </span>
                                <span
                                  className={cn(
                                    textVariants({ font: "medium" }),
                                    "whitespace-normal  "
                                  )}
                                >
                                  {data?.info?.trading_amount}
                                </span>
                              </div>
                              <div className="flex justify-between">
                                <span
                                  className={textVariants({ variant: "desc" })}
                                >
                                  {trans("details.unitPrice")}
                                </span>
                                <span
                                  className={textVariants({ font: "medium" })}
                                >
                                  {data?.info?.unit_price}
                                </span>
                              </div>
                              <div className="flex justify-between">
                                <span
                                  className={textVariants({ variant: "desc" })}
                                >
                                  {trans("details.quantity")}
                                </span>
                                <span
                                  className={textVariants({ font: "medium" })}
                                >
                                  {data?.info?.quantity}
                                </span>
                              </div>
                              <div className="flex justify-between">
                                <span
                                  className={textVariants({ variant: "desc" })}
                                >
                                  {trans("details.orderNumber")}
                                </span>
                                <span
                                  className={textVariants({ font: "medium" })}
                                >
                                  <div className="flex items-center gap-2">
                                    <span
                                      className={cn(
                                        "hidden md:flex",
                                        textVariants({ font: "medium" })
                                      )}
                                    >
                                      {data?.info?.order_no}
                                    </span>
                                    <span
                                      className={cn(
                                        "md:hidden flex",
                                        textVariants({ font: "medium" })
                                      )}
                                    >
                                      {_.truncate(data?.info?.order_no, {
                                        length: 20,
                                      })}
                                    </span>
                                    <img
                                      onClick={() =>
                                        copy(data?.info?.order_no as string)
                                      }
                                      src={CopyIcon}
                                      className="h-5 w-5 cursor-pointer"
                                      alt=""
                                    />
                                  </div>
                                </span>
                              </div>
                              <div className="flex justify-between">
                                <span
                                  className={textVariants({ variant: "desc" })}
                                >
                                  {trans("details.orderTime")}
                                </span>
                                <span
                                  className={textVariants({ font: "medium" })}
                                >
                                  {moment(data?.info?.date).format("lll")}
                                </span>
                              </div>
                            </div>

                            <div className="grid gap-2">
                              <span
                                className={textVariants({
                                  variant: "desc",
                                  size: "sm",
                                })}
                              >
                                {trans("details.note")}
                              </span>
                            </div>
                            <div className="bg-[#EAF7F3] dark:bg-grey-600 p-2 grid gap-5 rounded-lg">
                              <div className="grid">
                                <span className={textVariants()}>
                                  {trans("details.terms")}
                                </span>
                                <span
                                  className={textVariants({
                                    variant: "desc",
                                    size: "sm",
                                  })}
                                >
                                  {data?.info?.terms}
                                </span>
                              </div>
                            </div>
                          </div>
                        ),
                      },
                      {
                        element: (
                          <div>
                            <div>
                              {data?.info?.type === "buyer" ? (
                                <span
                                  className={textVariants({ variant: "desc" })}
                                >
                                  {trans("details.confirmPaymentBuyer")}
                                </span>
                              ) : (
                                <span
                                  className={textVariants({ variant: "desc" })}
                                >
                                  {trans("details.confirmPaymentSeller")}
                                </span>
                              )}
                            </div>
                          </div>
                        ),
                      },
                    ]}
                  />
                </div>
              )}
              {data?.info.dispute_raised && (
                <div className="grid gap-3">
                  <div className="grid">
                    <span
                      className={textVariants({ size: "xl", font: "semibold" })}
                    >
                      {trans("dispute.title")}
                    </span>
                    <span className={textVariants({ variant: "desc" })}>
                      {trans("dispute.desc")}
                    </span>
                  </div>
                  <div className="grid gap-3">
                    <div className="flex justify-between">
                      <span className={textVariants({ variant: "desc" })}>
                        {data?.info?.type === "buyer"
                          ? trans("details.price.buyerTitle")
                          : trans("details.price.sellerTitle")}
                      </span>
                      <span className={textVariants({ font: "medium" })}>
                        {data?.info?.trading_amount}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className={textVariants({ variant: "desc" })}>
                        {trans("details.unitPrice")}
                      </span>
                      <span className={textVariants({ font: "medium" })}>
                        {data?.info?.unit_price}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className={textVariants({ variant: "desc" })}>
                        {trans("details.quantity")}
                      </span>
                      <span className={textVariants({ font: "medium" })}>
                        {data?.info?.quantity}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className={textVariants({ variant: "desc" })}>
                        {trans("details.orderNumber")}
                      </span>
                      <div className="flex items-center gap-2">
                        <span
                          className={cn(
                            textVariants({ font: "medium" }),
                            "hidden md:flex"
                          )}
                        >
                          {data?.info?.order_no}
                        </span>
                        <span
                          className={cn(
                            "md:hidden flex",
                            textVariants({ font: "medium" })
                          )}
                        >
                          {_.truncate(data?.info?.order_no, {
                            length: 20,
                          })}
                        </span>
                        <img
                          onClick={() => copy(data?.info?.order_no as string)}
                          src={CopyIcon}
                          className="h-5 w-5 cursor-pointer"
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="flex justify-between">
                      <span className={textVariants({ variant: "desc" })}>
                        {trans("details.orderTime")}
                      </span>
                      <span className={textVariants({ font: "medium" })}>
                        {moment(data?.info?.date).format("lll")}
                      </span>
                    </div>
                  </div>
                </div>
              )}

              <div className="mt-5 flex gap-5">
                <Actions actions={actions} data={data?.info} channel={id} />
              </div>
            </div>
          </div>
        )}
        {(!isMobile || (isMobile && tab === "chat")) && (
          <div>
            <Chat
              messages={messages}
              // client={wsClient}
              data={TradeDetails}
              partner={data?.info?.partner ?? ""}
            />
          </div>
        )}
      </div>

      <Modal open={successModal} setOpen={console.log} setter="state">
        <div>
          <div className="flex flex-col items-center justify-center gap-5">
            <img src={greenMark} alt="" className="h-24 w-24" />
          </div>
          <div>
            <div className="flex flex-col items-center justify-center gap-2">
              <span className={textVariants({ variant: "header" })}>
                {trans("completed.title")}
              </span>
              <span className={textVariants({ variant: "desc", size: "sm" })}>
                {trans("completed.desc", {
                  amount: successData?.trading_amount_crypto,
                  rate: successData?.unit_price,
                })}
              </span>
            </div>
            <div className="bg-gray-100 dark:bg-grey-600 p-3 rounded-md grid mt-5">
              <span className={textVariants()}>
                {trans("completed.transactionDetails")}
              </span>
              <div className="mt-5 grid gap-3">
                <div className="flex items-center justify-between">
                  <span className={textVariants({ variant: "desc" })}>
                    {trans("completed.orderId")}
                  </span>
                  <span className={textVariants({ font: "semibold" })}>
                    {successData?.order_no}
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <span className={textVariants({ variant: "desc" })}>
                    {trans("completed.date")}
                  </span>
                  <span className={textVariants({ font: "semibold" })}>
                    {moment(successData?.date).format("lll")}
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <span className={textVariants({ variant: "desc" })}>
                    {trans("completed.unitPrice")}
                  </span>
                  <span className={textVariants({ font: "semibold" })}>
                    {successData?.unit_price}
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <span className={textVariants({ variant: "desc" })}>
                    {trans("completed.tradingAmount")}
                  </span>
                  <span className={textVariants({ font: "semibold" })}>
                    {successData?.trading_amount}
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <span className={textVariants({ variant: "desc" })}>
                    {trans("completed.quantity")}
                  </span>
                  <span className={textVariants({ font: "semibold" })}>
                    {successData?.trading_amount_crypto}
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <span className={textVariants({ variant: "desc" })}>
                    {trans("completed.partner")}
                  </span>
                  <span className={textVariants({ font: "semibold" })}>
                    {successData?.partner}
                  </span>
                </div>
              </div>
            </div>
            <Button
              onClick={() => navigate("/app/trade/p2p")}
              className="w-full mt-4"
            >
              {trans("completed.continueButton")}
            </Button>
          </div>
        </div>
      </Modal>
    </Screen>
  );
};

export default TradeDetails;
